module.exports = __webpack_public_path__ + "img/input_user.a905e08a.png";